export const gridDebug = (() => {
	// Grid overlay
	const makeGrid = () => {
		if (document.getElementById("grid-debug")) return;
		const gridCtn = document.createElement("div");
		gridCtn.id = "grid-debug";
		gridCtn.className = "grid-debug";

		const gridWrapper = document.createElement("div");
		gridWrapper.className = "wpb-content-wrapper";

		const gridRow = document.createElement("div");
		gridRow.className = "vc_row";

		for (let i = 0; i < 12; i++) {
			const col = document.createElement("div");
			col.className = "vc_col-sm-1";
			col.appendChild(document.createElement("div"));
			gridRow.appendChild(col);
		}

		gridWrapper.appendChild(gridRow);
		gridCtn.appendChild(gridWrapper);
		document.body.appendChild(gridCtn);
	};

	// Show sections spacings
	const makeSectionOverlay = (showPaddingLines = true) => {
		if (document.getElementById("section-debug")) return;

		const sections = document.querySelectorAll("section");
		const overlay = document.createElement("div");
		overlay.id = "section-debug";
		Object.assign(overlay.style, {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			pointerEvents: "none",
		});
		document.body.appendChild(overlay);

		const drawLine = (y, color, text, labelPosition = "below") => {
			const line = document.createElement("div");
			Object.assign(line.style, {
				position: "absolute",
				top: `${y}px`,
				left: "0",
				height: "2px",
				width: "100%",
				backgroundColor: color,
			});

			const label = document.createElement("div");
			label.textContent = text;
			Object.assign(label.style, {
				position: "absolute",
				zIndex: 2,
				background: color,
				color: "white",
				fontSize: "12px",
				lineHeight: "1",
				padding: "4px 6px",
				top: labelPosition === "below" ? `${y + 2}px` : `${y - 20}px`,
				borderRadius: labelPosition === "below" ? "0 0 2px 2px" : "2px 2px 0 0",
				left: labelPosition === "below" ? "10px" : "auto",
				right: labelPosition === "below" ? "auto" : "10px",
			});

			if (showPaddingLines) {
				overlay.appendChild(line);
				overlay.appendChild(label);
			}
		};

		sections.forEach((section, index) => {
			const rect = section.getBoundingClientRect();
			const top = rect.top + window.scrollY;
			const bottom = rect.bottom + window.scrollY;

			const styleCurrent = window.getComputedStyle(section);
			const paddingTop = parseFloat(styleCurrent.paddingTop);
			const paddingBottom = parseFloat(styleCurrent.paddingBottom);

			// Padding
			drawLine(top, "rgba(32, 161, 255)", `${paddingTop}px`, "below");
			drawLine(bottom, "rgba(32, 161, 255)", `${paddingBottom}px`, "above");

			// Space between sections
			if (index < sections.length - 1) {
				const nextSection = sections[index + 1];
				const nextRect = nextSection.getBoundingClientRect();
				const nextTop = nextRect.top + window.scrollY;

				const styleNext = window.getComputedStyle(nextSection);
				const paddingTopNext = parseFloat(styleNext.paddingTop);

				const topPosition = bottom - paddingBottom;
				const bottomPosition = nextTop + paddingTopNext;
				const spacerHeight = bottomPosition - topPosition;

				const spacer = document.createElement("div");
				spacer.classList.add("debug-hatched");
				Object.assign(spacer.style, {
					position: "absolute",
					top: `${topPosition}px`,
					left: "0",
					zIndex: "1",
					width: "100%",
					height: `${spacerHeight}px`,
				});

				const label = document.createElement("div");
				label.textContent = `${paddingBottom + paddingTopNext}px`;
				Object.assign(label.style, {
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					background: "#20a1ff",
					color: "white",
					fontSize: "12px",
					padding: "2px 6px",
					borderRadius: "4px",
				});

				spacer.appendChild(label);
				overlay.appendChild(spacer);
			}
		});
	};

	// === MENU DEBUG ===
	const createDebugMenu = () => {
		const menuContainer = document.createElement("div");
		menuContainer.className = "debug-menu";

		const button = document.createElement("button");
		button.className = "debug-button";
		menuContainer.appendChild(button);

		const menu = document.createElement("div");
		menu.className = "debug-options";

		// Option Grille
		const gridOption = document.createElement("label");
		gridOption.className = "debug-option";
		const gridCheckbox = document.createElement("input");
		gridCheckbox.type = "checkbox";
		gridCheckbox.className = "debug-checkbox grid-checkbox";
		gridOption.appendChild(gridCheckbox);
		gridOption.appendChild(document.createTextNode("Afficher la grille"));
		menu.appendChild(gridOption);

		// Option Overlay
		const overlayOption = document.createElement("label");
		overlayOption.className = "debug-option";
		const overlayCheckbox = document.createElement("input");
		overlayCheckbox.type = "checkbox";
		overlayCheckbox.className = "debug-checkbox overlay-checkbox";
		overlayOption.appendChild(overlayCheckbox);
		overlayOption.appendChild(document.createTextNode("Afficher les espacements"));
		menu.appendChild(overlayOption);

		menuContainer.appendChild(menu);
		document.body.appendChild(menuContainer);

		// Toggle menu
		button.addEventListener("click", (e) => {
			e.stopPropagation();
			menu.parentElement.classList.toggle("is-open");
		});

		document.addEventListener("click", (e) => {
			const container = menu.parentElement;
			if (container.classList.contains("is-open") && !container.contains(e.target)) {
				container.classList.remove("is-open");
			}
		});

		// Restaurer état localStorage
		const gridVisible = localStorage.getItem("gridVisible") === "true";
		const overlayVisible = localStorage.getItem("overlayVisible") === "true";

		gridCheckbox.checked = gridVisible;
		overlayCheckbox.checked = overlayVisible;

		if (gridVisible) makeGrid();
		if (overlayVisible) makeSectionOverlay();

		// Gestion des checkboxes
		gridCheckbox.addEventListener("change", () => {
			const checked = gridCheckbox.checked;
			localStorage.setItem("gridVisible", checked);
			const grid = document.getElementById("grid-debug");
			if (checked && !grid) makeGrid();
			if (!checked && grid) grid.remove();
		});

		overlayCheckbox.addEventListener("change", () => {
			const checked = overlayCheckbox.checked;
			localStorage.setItem("overlayVisible", checked);
			const overlay = document.getElementById("section-debug");
			if (checked && !overlay) makeSectionOverlay();
			if (!checked && overlay) overlay.remove();
		});
	};

	// === INIT ===
	const init = () => {
		createDebugMenu();
	};

	return { init };
})();
